import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name theme.festzelt-os.component:alTopSearch
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <al-top-search></al-top-search>
 *
 */
angular
    .module('festzelt-os.theme.festzelt-os')
    .component('alTopSearch', {
        templateUrl: template,
        controllerAs: 'vm',
        controller: 'AlTopSearchCtrl',
        bindings: {
            onCloseTriggered: '&'
        }
    });



// WEBPACK FOOTER //
// ./src/app/theme/festzelt-os/components/al-top-search/component.js